import 'babel-polyfill';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf';
import 'url-search-params-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import configureStore from './store/store';
import App from './components/App';

import './styles/styles.scss';


const store = configureStore();

const jsx = (
  <Provider store={store}>
    <App />
  </Provider>
);

ReactDOM.render(jsx, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/app.jsx